import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Youtube, MapPin, Mail, Phone, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0A1F44] text-white pt-16 pb-8 relative overflow-hidden" data-id="element-118">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-119">
        <img src="https://cdn.magicpatterns.com/uploads/m6J56ydxbg1oA3N2Z1bP9T/ChatGPT_Image_Mar_16,_2026,_05_56_58_PM.png" alt="" className="w-full h-full object-cover object-center" data-id="element-120" />
        <div className="absolute inset-0 bg-[#0A1F44]/80" data-id="element-121" />
      </div>

      <div className="container-custom relative z-10" data-id="element-122">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-24 mb-20 items-center" data-id="element-123">
          {/* Logo Column */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-124">
            <Link to="/" className="flex items-center gap-4 group mb-4" data-id="element-125">
              <img src="https://cdn.magicpatterns.com/uploads/kgPfyhKNzmQ6jDdg2wxmuj/NEW_HOCC_LOGO_-_WEBSITE.png" alt="TheHousehold Logo" className="w-14 h-14 rounded-full shrink-0 shadow-lg shadow-red-900/20 object-cover" data-id="element-126" />
              <div className="flex flex-col" data-id="element-127">
                <div className="text-white font-montserrat text-lg md:text-xl font-base tracking-wide leading-tight flex flex-col" data-id="element-128">
                  <div className="flex items-baseline gap-1.5" data-id="element-129">
                    <span data-id="element-130">HOUSEHOLD</span>
                    <span className="text-[0.7em] font-normal opacity-90" data-id="element-131">
                      OF
                    </span>
                  </div>
                  <span data-id="element-132">CHRIST CHURCH</span>
                </div>
                <div className="flex items-center gap-2 text-white/80 text-[10px] sm:text-xs font-montserrat tracking-[0.2em] uppercase mt-2" data-id="element-133">
                  <div className="h-[1px] w-3 md:w-4 bg-white" data-id="element-134"></div>
                  <span className="text-[#fc0719] font-bold" data-id="element-135">THEHOUSEHOLD</span>
                  <div className="h-[1px] w-3 md:w-4 bg-white" data-id="element-136"></div>
                </div>
              </div>
            </Link>
          </div>

          {/* Social Links Column */}
          <div className="flex flex-col items-center text-center" data-id="element-137">
            <h3 className="font-medium text-lg tracking-[0.2em] uppercase mb-6 text-white" data-id="element-138">
              STAY CONNECTED
            </h3>
            <div className="flex gap-6" data-id="element-139">
              <a href="https://www.facebook.com/householdchurch" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-white flex items-center justify-center text-[#0A1F44] hover:bg-[#fc0719] hover:text-white transition-colors shadow-lg" aria-label="Facebook" data-id="element-140">
                <Facebook className="w-6 h-6" data-id="element-141" />
              </a>
              <a href="https://www.instagram.com/householdchurch" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-white flex items-center justify-center text-[#0A1F44] hover:bg-[#fc0719] hover:text-white transition-colors shadow-lg" aria-label="Instagram" data-id="element-142">
                <Instagram className="w-6 h-6" data-id="element-143" />
              </a>
              <a href="https://www.youtube.com/@householdchurch" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-white flex items-center justify-center text-[#0A1F44] hover:bg-[#fc0719] hover:text-white transition-colors shadow-lg" aria-label="YouTube" data-id="element-144">
                <Youtube className="w-6 h-6" data-id="element-145" />
              </a>
            </div>
          </div>

          {/* Contact Info Column */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-146">
            <ul className="space-y-4" data-id="element-147">
              <li className="flex items-center gap-4 text-white/90" data-id="element-148">
                <MapPin className="w-5 h-5 text-white shrink-0" data-id="element-149" />
                <span data-id="element-150">1221 Caraway Ct, #1090, Largo, MD 20774</span>
              </li>
              <li className="flex items-center gap-4 text-white/90" data-id="element-151">
                <Phone className="w-5 h-5 text-white shrink-0" data-id="element-152" />
                <div className="flex flex-col" data-id="element-153">
                  <a href="tel:301-996-6907" className="hover:text-[#fc0719] transition-colors" data-id="element-154">
                    (301) 996-6907
                  </a>
                </div>
              </li>
              <li className="flex items-center gap-4 text-white/90" data-id="element-155">
                <Mail className="w-5 h-5 text-white shrink-0" data-id="element-156" />
                <a href="mailto:info@householdchurch.org" className="hover:text-[#fc0719] transition-colors" data-id="element-157">
                  info@householdchurch.org
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Tagline & Copyright */}
        <div className="border-t border-white/20 pt-12 flex flex-col items-center gap-6 text-center" data-id="element-158">
          <h2 className="font-script text-2xl md:text-3xl lg:text-4xl text-white mb-4" style={{
          textShadow: '0 2px 10px rgba(0,0,0,0.3)'
        }} data-id="element-159">
            Encounter God • Belong to a Family • Fulfill Your Purpose
          </h2>
          <p className="text-white/60 text-sm" data-id="element-160">
            © {new Date().getFullYear()} Household of Christ Church – All
            Rights Reserved.
          </p>
        </div>
      </div>
    </footer>;
}